import React from "react";
import MainTemplate from "@/components/Templates/MainTemplate";
import LeftSideView from "./LeftSideView";
import RightSideView from "./RightSideView";
import { PageWrapper } from "./style";

function HealthNewsLetter() {
  return (
    <MainTemplate hideRibbon>
      <PageWrapper paddingLeft="0px" paddingRight="0px">
        <LeftSideView />
        <RightSideView />
      </PageWrapper>
    </MainTemplate>
  );
}

export default HealthNewsLetter;
